<template>
  <div class="search">
    <home-banner ref="homeBanner" :height="400"></home-banner>
    <div class="clear"></div>
    <div class="Tpage">
      <div id="PageLeft">
        <div class="Tit">
          <div class="img"><img src="../assets/img/zi_left_b.png"> </div>
          <div class="big">搜索结果</div>
          <div class="samll">
            匠心营造  精益求精
          </div>
        </div>
      </div>

      <div id="PageRight">
        <div class="nav">
          <div class="l" style="font-size: 14px;">{{mathedTitle}}</div>
          <div class="l2" style="font-size: 14px;">&nbsp;&nbsp;&nbsp;&nbsp;搜索关键词：{{searchValue}} </div>
          <div class="r">
            <span> 您当前的位置： </span>
            <span>
              <router-link to="/">首页 <span> &nbsp;> </span>  </router-link>
            </span>  
            <router-link to="/" class="textTitle">{{mathedTitle}}  </router-link>
          </div>
        </div>

        <div class="content">
          <div class="view">
            <div id="newList">
              <ul class="comUl" style="margin-left: -40px;">
                <li v-for="(item, index) in searchList" :key="index" >
                  <!-- <a
                    style="color: #535353; font-weight: 700;"
                    :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    target="_blank"
                    >{{ item.title | ellipsis}}</a
                  > -->
                  <a style="color: #535353; font-weight: 700;" v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title | ellipsis}}</a>
                  <a style="color: #535353; font-weight: 700;" v-else-if="(!item.url || item.url == '') && item.entTChannelUuid =='00190001'" target="_blank" :href="`/detail/yiji00020002/${item.entTArticleUuid}`">{{ item.title | ellipsis}}</a>
                  <a style="color: #535353; font-weight: 700;" v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{ item.title | ellipsis}}</a>
                  <span class="ri">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clear"></div>

        <div class="pagin">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            :pager-count="11"
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { articleSearch } from '@/api/common'
import homeBanner from "@/components/swiper.vue"
export default {
  components: {
      homeBanner
    },
  data() {
    return {    
      searchList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,  
      searchValue:'',
      mathedTitle:'搜索结果',     
    }
  },
  filters: {
      //超过100位显示 ...
      ellipsis: function(value) {
        if (!value) return "";
        if (value.length > 50) {
          return value.slice(0, 50) + "...";
        }
        return value;
      },
    }, 
  computed: {
  },
  mounted() {
    var _this = this
    _this.searchValue = _this.$route.params.title
    _this.articles()
  },
  methods: {
    articles() {
      var _this = this

      let data = {
        entTApplicationUuid: _this.webId,
        title: _this.searchValue,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }
      articleSearch(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.searchList = data.rows
          _this.total = data.totalRows
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      var _this = this
      _this.pageNum = val
      _this.articles()
    }
    
  },
}
</script>
<style lang="scss">
.search{
  margin-bottom: 20px;
}
.clear {
  width: 100%;
  height: 20px;
  overflow: hidden;
  display: block;
  clear: both;
}
.Tpage {
  width: 1200px;
  overflow: hidden;
  margin: 0px auto;
}
#PageLeft {
  width: 235px;
  float: left;
  overflow: hidden;
}
#PageLeft .Tit {
  width: 235px;
  height: 230px;
  background-color: #0062b3;
  color: #FFFFFF;
  position: absolute;
  margin-top: -136px;
  z-index: 9999999;
}
#PageLeft .Tit .img {
  width: 64px;
  height: 73px;
  margin: 26px auto 0px auto;
}
img {
  display: inline-block;
  border: none;
}
#PageLeft .Tit .big {
  width: 100%;
  height: 54px;
  line-height: 54px;
  text-align: center;
  font-size: 24px;
  margin-top: 4px;
}
#PageLeft .Tit .samll {
  width: 100%;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  text-align: center;
  color: #97bde1;
  margin-top: 10px;
}
#PageRight {
  width: 930px;
  float: right;
  overflow: hidden;
}
#PageRight .nav {
  width: 100%;
  height: 35px;
  border-bottom: 1px #d6d6d6 solid;
}
#PageRight .nav .l {
  width: 100px;
  height: 35px;
  line-height: 35px;
  float: left;
}
#PageRight .nav .l2 {
  width: 430px;
  height: 35px;
  line-height: 35px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
}
#PageRight .nav .r {
  width: 400px;
  text-align: right;
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  float: right;
  font-size: 12px;
  color: #9a9a9a;
}
#PageRight .nav .r a {
  font-size: 12px;
  color: #9a9a9a;
}
.content {
  font-size: 16px;
  line-height: 30px;
  padding: 0px;
}
.content .view {
  padding: 0px 10px;
}

.content .view .comUl li{
  font: 14px "Helvetica Neue", Helvetica, "PingFang SC", 微软雅黑, Tahoma, Arial, sans-serif;
  border-bottom: 1px dotted rgb(180, 180, 180);
  overflow: hidden;
  padding: 15px 0px 15px 40px;
  margin-top: 10px;
  color: #535353;
  font-size: 14px;
  font-weight: 500;
}

.content .view .comUl span{
  width: 90px;
  height: 30px;
  border-bottom: 2px #0062b3 solid;
  color: #000000;
  font-size: 13px;
  text-align: center;
  line-height: 30px;
  float: right;
}

a {
  font: 14px Helvetica Neue,Helvetica,PingFang SC,\5FAE\8F6F\96C5\9ED1,Tahoma,Arial,sans-serif;
}
.pagin{
  text-align: center;
}
</style>

